import { ScenarioAnchor, ScenarioVersion } from 'src/models/anchor-and-version/scenario.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-scenario-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudScenarioModalComponent extends CrudModalAbstractComponent<
    ScenarioAnchor,
    ScenarioVersion
> {
    public modalProps: ModalProps = {
        title: 'Scenario',
        anchorFields: [
            {
                field: 'scenarioId',
                label: 'Scenario ID',
                type: 'number',
                required: true,
                order: 2,
                uniqueCheck: true,
            },
            {
                field: 'useCaseAnchorKey',
                label: 'Use Case',
                type: 'lazy-dropdown',
                required: true,
                order: 3,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 4 },
            { field: 'englishDefinition', label: 'English Definition', type: 'textarea', order: 5 },
            { field: 'swedishName', label: 'Swedish Name', type: 'text', order: 6 },
            { field: 'swedishDefinition', label: 'Swedish Definition', type: 'textarea', order: 7 },
            {
                field: 'validConditionFpc',
                label: 'Formal Condition',
                type: 'textarea',
                required: true,
                order: 8,
            },
            {
                field: 'validConditionText',
                label: 'Informal Condition',
                type: 'textarea',
                order: 9,
            },
            { field: 'oasFpc', label: 'OAS FPC', type: 'textarea', order: 10 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 11 },
            { field: 'isActive', label: 'Is Active', type: 'switch', order: 12 },
        ],
    };
}
